/**
 * Created by sagil on 10/10/2016.
 */
import {
	Component,
	Output,
	EventEmitter,
	Input
} from "@angular/core";

@Component({
	selector: 'cp-popup-buttons-ok-cancel',
	template : `
		<cp-button-strip>
			<div class="primary-area">
				<cp-button-widget-custom class="primary-button"
					[cpFocus]="focusOnOK"
					[cpFocusOnChanges]="true"
					[titleToTranslate]="okLabel ? okLabel : 'OK'"
					[isDisabled]="okDisabled" [tooltipPlain]="okTooltipPlain"
					(onClick)="okDisabled ? null : ok.emit();">
				</cp-button-widget-custom>
			</div>
			<div class="secondary-area">
				<cp-button-widget-custom class="tertiary-button"
					[titleToTranslate]="cancelLabel ? cancelLabel : 'Cancel'"
					(onClick)="cancel.emit();">
				</cp-button-widget-custom>
			</div>
		</cp-button-strip>
`
})
export class PopupButtonsOkCancelComponent {

	@Input() okLabel: string;
	@Input() cancelLabel: string;
	@Input() okDisabled: boolean;
	@Input() okTooltipPlain : string;
	@Input() focusOnOK:boolean;

	@Output() ok = new EventEmitter();
	@Output() cancel = new EventEmitter();
}
